import * as React from 'react';
import { IconBank16 } from '@cian/ui-kit/icons';

import * as styles from './BanksList.css';
import { IPromoPopupBank } from '../../../../types/promosPage';
import { ListItem } from '../ListItem';

interface IBanksListProps {
  banks: IPromoPopupBank[];
}

export function BanksList({ banks }: IBanksListProps) {
  return (
    <>
      <h3 className={styles['title']}>Банки</h3>
      <ul className={styles['container']}>
        {banks.map((bank, idx) => (
          <li key={idx} className={styles['item']}>
            <ListItem name={bank.name} logoUrl={bank.logo} defaultIcon={<IconBank16 />} />
          </li>
        ))}
      </ul>
    </>
  );
}
